import axios from 'axios';
import { config } from '../../config';
import { adminAuthHeaders } from './authHeaders';

export async function getAdminReminders(params = {}) {
    const host = `${config.service.host}/api/admin`;
    const headers = await adminAuthHeaders();
    const { data } = await axios.get(`${host}/reminders`, {
        params,
        headers,
    });
    return data;
}
